// extracted by mini-css-extract-plugin
export default {"wrapper":"bE-z","viewport":"cE-z","container":"dE-z","slide":"eE-z"};